import { ContentHeader } from '../../components/layout/ContentHeader'
import { ComingSoon } from '../../components/ui/ComingSoon'
import { useParams } from 'react-router-dom'

export default function AuditLinks() {
  const { projectId } = useParams<{ projectId: string }>()
  return (
    <>
      <ContentHeader breadcrumb={[{ label: 'Audit de site Web', to: `/p/${projectId}/audit` }, { label: 'Liens trouves' }]} title="Liens trouves" />
      <ComingSoon title="Liens trouves" description="L'analyse des liens internes et externes avec statuts HTTP et attributs arrive bientot." />
    </>
  )
}
